import React from 'react';
import Input from './Input';

/**
 * @type {import('./types').FieldTransformStrategy}
 */
const transform = {
  fromServer: Input.transform.fromServer,
  toServer: Input.transform.toServer,
  defaultValue: Input.transform.defaultValue,
};

const Number = React.memo(function Number(props) {
  return (
    <Input type="number" step="any" onWheel={(e) => e.currentTarget.blur()} {...props} />
  );
});

Number.transform = transform;
export default Number;
